import { render, staticRenderFns } from "./TaxabilityAvatax.vue?vue&type=template&id=ea4d759e&scoped=true"
import script from "./TaxabilityAvatax.vue?vue&type=script&lang=ts"
export * from "./TaxabilityAvatax.vue?vue&type=script&lang=ts"
import style0 from "./TaxabilityAvatax.vue?vue&type=style&index=0&id=ea4d759e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea4d759e",
  null
  
)

export default component.exports